import React from 'react';
import { createRoot } from 'react-dom/client';
import { msalInstance } from '@sib/auth';
import { initI18n } from '@sib/i18n';
import { tracking } from '@sib/tracking';
import App from './core/App';

tracking.init();

(async () => {
  await initI18n();

  const container = document.getElementById('root');
  const root = createRoot(container!);
  msalInstance.initialize().then(() => {
    root.render(
      <React.StrictMode>
        <React.Suspense>
          <App />
        </React.Suspense>
      </React.StrictMode>
    );
  });
})();
